import React from 'react'
import Header from '../_components/common/Header'
import AssignmentUI from '../_components/UI/AssignmentUI'

const Assignment = () => {
  return (
    <div className='page-main'>
        <Header name = {["Assignment Monitoring"]}/>
        <AssignmentUI />


    </div>
  )
}

export default Assignment